import React, { useCallback, useEffect, useState } from 'react';
import { Search, UserPlus, Copy } from 'lucide-react';
import { api } from '../../../context/AuthContext';
import { toast } from 'sonner';

const fehler = (e) => toast.error(e?.response?.data?.detail || 'Aktion fehlgeschlagen');
const feld = 'h-9 px-3 rounded-[10px] border border-gray-200 bg-white text-[13px] focus:outline-none focus:border-[#1B3A5C] focus:ring-2 focus:ring-[#e0b56a]/40';

const Konto = ({ k, akten, katalog, darf, onChange }) => {
  const patch = (body) => api.patch(`/kanzlei/rechte/mandantenkonten/konto/${k.id}`, body).then((r) => { onChange(r.data.konten); toast.success('Gespeichert'); }).catch(fehler);
  const entziehen = () => window.confirm('Zugang wirklich entziehen?') && api.delete(`/kanzlei/rechte/mandantenkonten/konto/${k.id}`).then((r) => onChange(r.data.konten)).catch(fehler);
  const mit = k.rolle === 'mitnutzer';
  const toggle = (liste, x) => (liste.includes(x) ? liste.filter((y) => y !== x) : [...liste, x]);
  return (
    <li className="p-4" data-testid={`konto-${k.id}`}>
      <div className="flex flex-wrap items-center gap-2">
        <div className="flex-1 min-w-[180px]"><p className="text-[#1B3A5C] font-medium">{k.name || k.email}</p><p className="text-xs text-gray-500">{k.email}</p></div>
        <select disabled={!darf} value={k.rolle} onChange={(e) => patch({ rolle: e.target.value })} className={feld} data-testid={`konto-rolle-${k.id}`}>
          <option value="inhaber">Inhaber</option><option value="mitnutzer">Mitnutzer</option>
        </select>
        <button type="button" disabled={!darf} onClick={() => patch({ aktiv: !k.aktiv })} className={`h-9 px-3 rounded-[10px] border text-[12px] ${k.aktiv ? 'border-emerald-200 text-emerald-700' : 'border-rose-200 text-rose-700'}`} data-testid={`konto-aktiv-${k.id}`}>{k.aktiv ? 'Aktiv' : 'Gesperrt'}</button>
        {darf && <button type="button" onClick={entziehen} className="text-[12px] text-rose-700 hover:underline" data-testid={`konto-entziehen-${k.id}`}>Zugang entziehen</button>}
      </div>
      {mit && (
        <div className="mt-3 space-y-2">
          <div className="flex flex-wrap gap-1.5">
            {katalog.portal_rechte.map((r) => (
              <label key={r.key} className="inline-flex items-center gap-1.5 text-[12px] px-2.5 py-1 rounded-full border border-gray-200">
                <input type="checkbox" disabled={!darf} checked={k.rechte.includes(r.key)} onChange={() => patch({ rechte: toggle(k.rechte, r.key) })} className="accent-[#1B3A5C]" data-testid={`konto-recht-${k.id}-${r.key}`} />{r.label}
              </label>
            ))}
          </div>
          <div className="flex flex-wrap items-center gap-1.5 text-[12px]">
            <span className="text-gray-500">Akten:</span>
            <button type="button" disabled={!darf} onClick={() => patch({ akten: null })} className={`px-2.5 py-1 rounded-full border ${!k.akten ? 'bg-[#1B3A5C] text-white border-[#1B3A5C]' : 'border-gray-200'}`} data-testid={`konto-akten-alle-${k.id}`}>Alle</button>
            {akten.map((a) => {
              const on = (k.akten || []).includes(a.anfrage_id);
              return <button key={a.anfrage_id} type="button" disabled={!darf} onClick={() => patch({ akten: toggle(k.akten || [], a.anfrage_id) })} className={`px-2.5 py-1 rounded-full border ${on ? 'bg-[#1B3A5C] text-white border-[#1B3A5C]' : 'border-gray-200'}`}>{a.aktenzeichen || a.rechtsgebiet || a.anfrage_id}</button>;
            })}
          </div>
        </div>
      )}
    </li>
  );
};

const Einladen = ({ mnr, katalog, onDone }) => {
  const [f, setF] = useState({ name: '', email: '', rolle: 'mitnutzer', rechte: ['lesen', 'upload'], zustimmung_textform: false });
  const [code, setCode] = useState('');
  const senden = async (e) => {
    e.preventDefault();
    try { const r = await api.post(`/kanzlei/rechte/mandantenkonten/${mnr}/einladen`, f); setCode(r.data.code); toast.success('Einladung mit Code versendet'); onDone(); } catch (err) { fehler(err); }
  };
  return (
    <form onSubmit={senden} className="p-4 bg-[#f9fbfc] border-t border-gray-100 space-y-2" data-testid="konto-einladen-form">
      <div className="flex flex-wrap gap-2">
        <input required placeholder="Name" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} className={`${feld} flex-1 min-w-[150px]`} data-testid="konto-einladen-name" />
        <input required type="email" placeholder="E-Mail" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} className={`${feld} flex-1 min-w-[180px]`} data-testid="konto-einladen-email" />
        <select value={f.rolle} onChange={(e) => setF({ ...f, rolle: e.target.value })} className={feld} data-testid="konto-einladen-rolle"><option value="mitnutzer">Mitnutzer</option><option value="inhaber">Inhaber</option></select>
        <button className="h-9 px-4 rounded-[10px] bg-[#1B3A5C] text-white text-[13px] inline-flex items-center gap-2" data-testid="konto-einladen-senden"><UserPlus className="w-4 h-4" /> Einladen</button>
      </div>
      {f.rolle === 'mitnutzer' && (
        <>
          <div className="flex flex-wrap gap-1.5">{katalog.portal_rechte.map((r) => (
            <label key={r.key} className="inline-flex items-center gap-1.5 text-[12px] px-2.5 py-1 rounded-full border border-gray-200 bg-white">
              <input type="checkbox" checked={f.rechte.includes(r.key)} onChange={() => setF({ ...f, rechte: f.rechte.includes(r.key) ? f.rechte.filter((x) => x !== r.key) : [...f.rechte, r.key] })} className="accent-[#1B3A5C]" />{r.label}
            </label>))}
          </div>
          <label className="flex items-start gap-2 text-xs text-[#1B3A5C]"><input type="checkbox" checked={f.zustimmung_textform} onChange={(e) => setF({ ...f, zustimmung_textform: e.target.checked })} className="mt-0.5 accent-[#b8893d]" data-testid="konto-einladen-zustimmung" />
            Der Mandant hat der Freigabe in Textform zugestimmt (§ 43a Abs. 2 BRAO, § 203 StGB).</label>
        </>
      )}
      {code && <p className="text-[13px] text-[#1B3A5C] inline-flex items-center gap-2" data-testid="konto-einladen-code">Code (14 Tage gültig): <strong className="tracking-widest">{code}</strong>
        <button type="button" onClick={() => navigator.clipboard?.writeText(code)} aria-label="Code kopieren"><Copy className="w-4 h-4 text-[#b8893d]" /></button></p>}
    </form>
  );
};

export const MandantenKonten = ({ katalog, startNr }) => {
  const [q, setQ] = useState(startNr || '');
  const [treffer, setTreffer] = useState([]);
  const [nr, setNr] = useState(startNr || '');
  const [detail, setDetail] = useState(null);
  const darf = katalog.meine_rechte.includes('portalkonten');
  useEffect(() => { const t = setTimeout(() => api.get('/kanzlei/rechte/mandantenkonten', { params: { q } }).then((r) => setTreffer(r.data)).catch(() => {}), 250); return () => clearTimeout(t); }, [q]);
  const laden = useCallback(() => nr && api.get(`/kanzlei/rechte/mandantenkonten/${nr}`).then((r) => setDetail(r.data)).catch(fehler), [nr]);
  useEffect(() => { laden(); }, [laden]);
  return (
    <div className="grid lg:grid-cols-[320px_1fr] gap-4" data-testid="rechte-mandantenkonten">
      <div className="bg-white border border-gray-200 rounded-2xl p-3">
        <div className="relative"><Search className="w-4 h-4 absolute left-3 top-2.5 text-gray-400" />
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Name, Mandantennummer, E-Mail" className={`${feld} w-full pl-9`} data-testid="konten-suche" /></div>
        <ul className="mt-2 max-h-[420px] overflow-y-auto">
          {treffer.map((m) => (
            <li key={m.mandanten_nr}><button type="button" onClick={() => setNr(m.mandanten_nr)} data-testid={`konten-treffer-${m.mandanten_nr}`}
              className={`w-full text-left px-3 py-2 rounded-[10px] text-[13px] transition-colors ${nr === m.mandanten_nr ? 'bg-[#1B3A5C] text-white' : 'hover:bg-[#f5f8fa] text-[#1B3A5C]'}`}>
              {m.name} <span className="opacity-60">· {m.mandanten_nr} · {m.konten} Konto/Konten</span></button></li>
          ))}
        </ul>
      </div>
      <div className="bg-white border border-gray-200 rounded-2xl">
        {!detail ? <p className="p-6 text-sm text-gray-500">Mandant wählen.</p> : (
          <>
            <div className="p-4 border-b border-gray-100"><p className="font-serif text-lg text-[#1B3A5C]">{detail.mandant.name}</p><p className="text-xs text-gray-500">Mandantennummer {detail.mandant.mandanten_nr}</p></div>
            <ul className="divide-y divide-gray-100">
              {detail.konten.map((k) => <Konto key={k.id} k={k} akten={detail.akten} katalog={katalog} darf={darf} onChange={(konten) => setDetail({ ...detail, konten })} />)}
              {!detail.konten.length && <li className="p-4 text-sm text-gray-500">Noch kein Portalkonto.</li>}
            </ul>
            {detail.einladungen.length > 0 && <p className="px-4 pb-3 text-xs text-gray-500">Offene Einladungen: {detail.einladungen.map((e) => e.email || e.name).join(', ')}</p>}
            {darf && <Einladen mnr={detail.mandant.mandanten_nr} katalog={katalog} onDone={laden} />}
          </>
        )}
      </div>
    </div>
  );
};
